import React from 'react';

const team = [
  { name: 'Technology Director', role: 'CTO', icon: '👨‍💻', desc: 'Expert in software architecture and emerging technologies.' },
  { name: 'Operations Head', role: 'COO', icon: '👩‍💼', desc: 'Driving operational excellence across global offices.' },
  { name: 'Sales Director', role: 'VP Sales', icon: '🤝', desc: 'Building strong client relationships across industries.' },
];

const ManagementTeam = () => (
  <>
    <section className="py-5 text-white text-center" style={{ background: 'linear-gradient(135deg, #002868, #1a56db)' }}>
      <div className="container py-4">
        <h1 className="fw-bold">Management Team</h1>
        <p className="lead" style={{ color: '#cbd5e1' }}>The people behind EGB's success</p>
      </div>
    </section>

    <section className="py-5 bg-light">
      <div className="container py-4">
        <div className="row g-4 justify-content-center">
          {team.map((member, i) => (
            <div key={i} className="col-12 col-sm-6 col-lg-3">
              <div className="card border-0 shadow-sm h-100 text-center p-4">
                <div style={{ fontSize: 60, background: '#dbeafe', borderRadius: '50%', width: 90, height: 90, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px' }}>{member.icon}</div>
                <h5 className="fw-bold mb-1">{member.name}</h5>
                <span className="badge bg-primary mb-3">{member.role}</span>
                <p className="text-muted small">{member.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  </>
);

export default ManagementTeam;
